import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=4576a6e9&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"
import style0 from "./supplier.vue?vue&type=style&index=0&id=4576a6e9&lang=less&scoped=true&"
import style1 from "./supplier.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4576a6e9",
  null
  
)

component.options.__file = "supplier.vue"
export default component.exports